import { TemplatePage } from './types';

const live_streaming_brb_screens_page: TemplatePage = {
  header: {
    color: '#F3CB5A',
    icon: 'images/video-templates/streaming_break.jpg',
    title: 'Be Right Back Screen Templates',
    title_meta: '20+ Free Be Right Back Screen Templates ',
    description_meta:
      'Design stylish Be Right Back screen for your live stream with the help of Wave.video’s ' +
      'free and easily customizable templates. Impress viewers even when you’re on pause.',
    description:
      'Pick a template that matches your style and quickly design a high-quality Be Right Back ' +
      'screen for your live streams. Use this overlay to make your live shows look professional, ' +
      'even if you have to make an urgent break.'
  },
  footer: {
    category: 'be right back screen',
    description:
      'With Wave.video’s collection of editable templates, you can create a pack of consistent visual assets ' +
      'that reflect your style and improve brand recognition. With no design background, you create a complete ' +
      'set of overlays for your live streams, including Technical Difficulties and Be Right Back screens, countdown, ' +
      'transparent lower third, and many more! Use Wave.video templates to make a professional set of visuals once ' +
      'and kickstart your successful live streaming career.'
  },
  content: [
    {
      type: 'templates',
      title: 'Be Right Back Screen Templates',
      search: { name: 'LiveBrb', tags: 'LiveBrb' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_brb_screens_page;
